import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_LOCATION = requestConstantsMaker('GET_ALL_LOCATION');
export const GET_LOCATION = requestConstantsMaker('GET_LOCATION');
export const CREATE_LOCATION = requestConstantsMaker('CREATE_LOCATION');
export const UPDATE_LOCATION = requestConstantsMaker('UPDATE_LOCATION');
export const GET_LOCATIONS_FOR_SELECTION = requestConstantsMaker('GET_LOCATIONS_FOR_SELECTION');
/**** 20200217 ****/

export const GET_ALL_LOCATION_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_LOCATION_BY_SPECIFICATION');
export const GET_LOCATION_BY_ID = requestConstantsMaker('GET_LOCATION_BY_ID');
export const POST_CREATE_LOCATION = requestConstantsMaker('POST_CREATE_LOCATION');
export const PUT_UPDATE_LOCATION = requestConstantsMaker('PUT_UPDATE_LOCATION');
